import "./LandingPage.css";

export default function LandingPage() {
  return (
    <div className="landing-container">
      {/* Background blobs */}
      <div className="ambient-bg">
        <div className="blob blob-1"></div>
        <div className="blob blob-2"></div>
      </div>

      {/* Header */}
      <header className="landing-header">
        <h1 className="logo-text">
          Huddlezen
          <span className="logo-dot"></span>
        </h1>
        <div style={{ display: "flex", gap: "1.5rem", alignItems: "center" }}>
          <a href="https://app.huddlezen.com/status" className="nav-link">
            System Status
          </a>
          <a href="https://app.huddlezen.com/signin" className="nav-link" style={{ fontWeight: 700 }}>
            Sign In
          </a>
          <a href="https://app.huddlezen.com/signup" className="nav-link" style={{ background: "#C08A6E", color: "#FFF", padding: "0.4rem 0.8rem", borderRadius: "6px" }}>
            Sign Up
          </a>
        </div>
      </header>

      {/* Main hero area */}
      <main className="landing-main">
        <div className="hero-left">
          <div className="tagline">Now in Rebuild</div>
          <h2 className="hero-title">
            The minimalist office <br />
            for <em>focused teams</em>
          </h2>
          <p className="hero-description">
            Huddlezen replaces cluttered, noisy collaboration spaces with a
            modular, high-performance spatial arena. Realtime voice huddles,
            accountable action items, and minimum cognitive load.
          </p>
          <div className="cta-group">
            <button
              className="cta-button"
              onClick={() =>
                window.location.href = "https://app.huddlezen.com/signup"
              }
            >
              Request Access
            </button>
            <button className="secondary-button" onClick={() => window.location.href = "https://app.huddlezen.com/status"}>
              Diagnostics
            </button>
          </div>
        </div>

        {/* Visual interactive kinetic node card */}
        <div className="hero-right">
          <div className="visual-canvas">
            <div className="visual-node-group">
              <div className="visual-node node-voice">Voice</div>
              <div className="visual-node node-spatial">Spatial</div>
              <div className="visual-node node-tasks">Tasks</div>
            </div>
            <div className="visual-conn"></div>
          </div>
        </div>
      </main>

      {/* Editorial footer */}
      <footer className="landing-footer">
        <div className="footer-left">
          <span>Alpha 0.1.0</span>
          <span>FastAPI + React + Supabase + LiveKit</span>
        </div>
        <div>
          <span>
            &copy; {new Date().getFullYear()} Huddlezen. All rights reserved.
          </span>
        </div>
      </footer>
    </div>
  );
}
